import React, { FC, useContext, useEffect, useState } from 'react';

import { CONSENT_COOKIE } from './consts';
import { BreakpointsContext } from '@src/providers/Breakpoints';
import { Unit } from '@src/core/Unit';
import { Box } from '@src/atoms/Box';
import { Text } from '@src/atoms/Text';
import { Button } from '@src/atoms/Button';
import { IClassNameProps, ILinkComponent, IStylesProps } from '@src/models/props';
import { classnames } from '@src/utils/classnames';
import { COMMON_LINKS } from '@src/consts/links';
import { getCookie, ICookieOptions, setCookie } from '@src/utils/cookies';

import styled from './PopupCookies.scss';

interface IPopupCookiesProps extends IClassNameProps, IStylesProps, ILinkComponent {}

/** Компонент уведомления об использовании cookies */
export const PopupCookies: FC<IPopupCookiesProps> = ({ className, style }) => {
  const [isShow, setIsShow] = useState(false);
  const { isMobile } = useContext(BreakpointsContext);

  const classes = classnames(className, styled.root, {
    [styled.approved]: !isShow,
  });

  const handleClick = () => {
    if (isShow) {
      setIsShow(false);

      // Второй раз мы должны спросить тольуо через 1 год
      const expires = new Date();
      expires.setFullYear(expires.getFullYear() + 1);
      const options: ICookieOptions = { expires };

      if (location.hostname === 'localhost') {
        options.domain = false;
      }

      setCookie(CONSENT_COOKIE, `true`, options);
    }
  };

  useEffect(() => {
    const newIsShow = getCookie(CONSENT_COOKIE);
    if (newIsShow !== 'true') {
      setIsShow(true);
    }
  }, []);

  if (!isShow) {
    return null;
  }

  return (
    <Unit id={'PopupCookies'}>
      <Box className={classes} style={style} justifyContent={'center'} column={isMobile} padding={{ MOBILE: 16 }}>
        <Box alignItems={'center'} paddingRight={{ DESKTOP: 20 }} marginBottom={{ MOBILE: 24 }}>
          <Text id={'description'} align={isMobile ? 'center' : 'right'} style={{ fontSize: isMobile ? 18 : 20 }}>
            Мы используем cookies для быстрой и удобной работы сайта
          </Text>
        </Box>
        <Box alignItems={'center'} justifyContent={{ MOBILE: 'spaceBetween' }} fullWidth={isMobile}>
          <Box>
            <Button size="md" onClick={handleClick} id={'applyBtn'}>
              Хорошо
            </Button>
          </Box>
          <Box marginLeft={24}>
            <Button size="md" href={COMMON_LINKS.PRIVACY.href} view="secondaryLight" id={'privacyLink'}>
              Узнать больше
            </Button>
          </Box>
        </Box>
      </Box>
    </Unit>
  );
};
